import React from 'react';
import { FaDatabase, FaExchangeAlt, FaSnowflake, FaLeaf } from 'react-icons/fa';
import { BsBraces } from 'react-icons/bs';
import { GrMysql } from 'react-icons/gr';
import RedshiftIcon from 'react-aws-icons/dist/aws/logo/Redshift';
import S3Icon from 'react-aws-icons/dist/aws/logo/S3';

import { SiPostgresql, SiOracle, SiMariadb, SiMysql, SiMongodb, SiMicrosoftsqlserver, SiAmazondynamodb, SiSalesforce } from 'react-icons/si';

// The data source picker is now driven by /api/v1/drivers (one option per registered_driver_types
// row). This static list is retained as a fallback / icon source for legacy code paths and
// utilities that still key on engine. File selectors (s3, sftp) and MongoDB are intentionally
// excluded from THIS legacy options list — file-source flows are handled separately, and
// MongoDB is offered by SourceForm's static NOSQL_OPTIONS entry (it doesn't come from the
// driver registry). Mongo is fully supported: discovery, profiling, test-connection, and
// mongodb→mongodb masking.
const options  = [
  {
    value: 'snowflake',
    label: 'Snowflake',
    icon: <FaSnowflake color='#c2d8f6' />
  },
  {
    value: 'mysql',
    label: 'MySQL',
    icon: <GrMysql color='#004d5c' />
  },
  {
    value: 'postgresql',
    label: 'PostgreSQL',
    icon: <SiPostgresql color='#007bc6' />
  },
  {
    value: 'oracledb',
    label: 'OracleDB',
    icon: <SiOracle color='#ff5151' />
  },
  {
    value: 'mssql',
    label: 'MS SQL Server',
    icon: <SiMicrosoftsqlserver color='#ff6d6d' />
  },
  {
    value: 'redshift',
    label: 'Amazon Redshift',
    icon: <RedshiftIcon color='#ff866b' />
  },
  {
    value: 'mariadb',
    label: 'MariaDB',
    icon: <SiMariadb color='#1D2E5B' />
  }
];

const labels = {
  'postgresql': 'PostgreSQL',
  'mysql': 'MySQL',
  'oracledb': 'OracleDB',
  'mssql': 'SQL Server',
  'redshift': 'Amazon Redshift',
  'mariadb': 'MariaDB',
  's3': 'Amazon S3',
  'snowflake': 'Snowflake',
  'mongodb': 'MongoDB',
  'dynamodb': 'DynamoDB',
  'salesforce': 'Salesforce',
  'jdbc': 'JDBC',
  'stream': 'Stream'
};

const icons = {
  'postgresql': <FaDatabase className='mr-2' size='1.1rem' color='#0077FF' />,
  'mysql': <FaDatabase className='mr-2' size='1.1rem' color='#0077FF' />,
  'oracledb': <FaDatabase className='mr-2' size='1.1rem' color='#0077FF' />,
  'mssql': <FaDatabase className='mr-2' size='1.1rem' color='#0077FF' />,
  'redshift': <RedshiftIcon className='mr-2' size='1.1rem' />,
  'mariadb': <FaDatabase className='mr-2' size='1.1rem' color='#0077FF' />,
  's3': <S3Icon className='mr-2' size='1.1rem' color='#EFBD39' />,
  'snowflake': <FaSnowflake className='mr-2' size='1.1rem' color='#83A1C4' />,
  'mongodb': <FaLeaf className='mr-2' size='1.1rem' color='#00B93F' />,
  'dynamodb': <SiAmazondynamodb className='mr-2' size='1.1rem' color='#4053D6' />,
  'salesforce': <SiSalesforce className='mr-2' size='1.1rem' color='#00A1E0' />,
  'jdbc': <BsBraces className='mr-2' size='1.1rem' color='#000' />,
  'stream': <FaExchangeAlt className='mr-2' size='1.1rem' color='#0077FF' />
}

const radialIcons = {
  's3': <S3Icon className='radial-card-meta-icon' color='#ff866b' />,
  'redshift': <RedshiftIcon className='radial-card-meta-icon' color='#ff866b' />,
  'snowflake': <FaSnowflake className='radial-card-meta-icon' color='#c2d8f6' />,
  'mysql': <SiMysql className='radial-card-meta-icon' color='#00a4c2' />,
  'postgresql': <SiPostgresql className='radial-card-meta-icon' color='#007bc6' />,
  'mongodb': <SiMongodb className='radial-card-meta-icon' color='#66b16a' />,
  'dynamodb': <SiAmazondynamodb className='radial-card-meta-icon' color='#4053D6' />,
  'salesforce': <SiSalesforce className='radial-card-meta-icon' color='#00A1E0' />,
  'mssql': <SiMicrosoftsqlserver className='radial-card-meta-icon' color='#ff6d6d' />,
  'oracledb': <SiOracle className='radial-card-meta-icon' color='#ff5151' />,
  'mariadb': <SiMariadb className='radial-card-meta-icon' color='#1D2E5B' />,
  'jdbc': <BsBraces className='radial-card-meta-icon' color='#000' />,
  'stream': <FaExchangeAlt className='mr-2' size='1.1rem' color='#0077FF' />
}
export default {
  icons,
  labels,
  options,
  radialIcons
};
